import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { UserService } from '@sharedcommon/services/user.service';

@Injectable()
export class HasEntityGuard implements CanActivate, CanActivateChild {

  constructor(
    private readonly router: Router,
    private readonly userService: UserService
  ) { }

  canActivate(): Observable<boolean> {
    const hasEntity = this.userService.getActivity() != null && this.userService.getEntity() != null;

    if (!hasEntity) {
      this.router.navigate(['/entity']);
    }

    return of(hasEntity);
  }

  canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }

}
